import { useState } from "react";
import "./ActiveSessionsPage.css";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

function AnswerRow({ answer }) {
  const [expanded, setExpanded] = useState(false);
  const isCorrect = answer.evaluation === 1;
  const toggleExpand = () => setExpanded(!expanded);

  // Check if subquestion
  const isSubquestion = !!answer.subquestion_id;

  const rowClass = isSubquestion
    ? "answer-row subquestion-answer"
    : "answer-row main-question-card";

  const questionText = answer.question?.body ?? "No question text";
  const subquestionText = answer.subquestion?.body ?? null;

  return (
    <div className={rowClass}>
      <div className="answer-main">
        <span className="question-body">
          {/* {questionText} */}
          {!subquestionText && (
            <>
              <br />
              {questionText}
            </>
          )}
          {subquestionText && (
            <>
              <br />
              {subquestionText}
            </>
          )}

          <br />
          (Attempt {answer.attempt})
        </span>

        {!isCorrect && (
          <button className="expand-btn" onClick={toggleExpand}>
            {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </button>
        )}

        <span className={`answer-status ${isCorrect ? "correct" : "incorrect"}`}>
          {isCorrect ? "Correct" : "Incorrect"}
        </span>
      </div>

      {!isCorrect && expanded && (
        <div className="answer-details">
          <p>
            <strong>Student's Answer:</strong> {answer.answer}
          </p>
          {answer.hint && (
            <p>
              <strong>Hint Given:</strong> {answer.hint}
            </p>
          )}
        </div>
      )}
    </div>
  );
}

export default AnswerRow;
